"use client";

import { cn } from "../../lib/utils";
import { motion, stagger, useAnimate, useInView } from "motion/react";
import { useEffect, useState } from "react";

export const TypewriterEffect = ({
    words,
    className,
    cursorClassName,
    cursorFinishedClassName
}: {
    words: {
        text: string;
        className?: string;
    }[];
    className?: string;
    cursorClassName?: string;
    cursorFinishedClassName?: string;
}) => {
    // split text inside of words into array of characters
    const wordsArray = words.map(word => {
        return {
            ...word,
            text: word.text.split("")
        };
    });

    const [scope, animate] = useAnimate();
    const isInView = useInView(scope);
    const [finished, setFinished] = useState(false);
    useEffect(() => {
        if (isInView) {
            const delayTimeout = setTimeout(() => {
                animate(
                    "span",
                    {
                        display: "inline-block",
                        opacity: 1,
                        width: "fit-content"
                    },
                    {
                        duration: 0.3,
                        delay: stagger(0.1),
                        ease: "linear"
                    }
                ).then(() => {
                    setTimeout(() => setFinished(true), 1300);
                });
            }, 1600);
            return () => clearTimeout(delayTimeout);
        }
    }, [isInView]);

    const renderWords = () => {
        return (
            <motion.div ref={scope} className="inline">
                {wordsArray.map((word, idx) => {
                    return (
                        <div key={`word-${idx}`} className="inline-block">
                            {word.text.map((char, index) => (
                                <motion.span
                                    initial={{ width: 0 }}
                                    key={`char-${index}`}
                                    className={cn(`dark:text-white text-black opacity-1 hidden`, word.className)}
                                >
                                    {char === " " ? "\u00A0" : char}
                                </motion.span>
                            ))}
                        </div>
                    );
                })}
            </motion.div>
        );
    };
    return (
        <div className={cn("text-base sm:text-xl md:text-3xl lg:text-5xl font-bold text-center", className)}>
            {renderWords()}
            {!finished ? (
                <motion.span
                    initial={{
                        opacity: 0
                    }}
                    animate={{
                        opacity: 1
                    }}
                    transition={{
                        duration: 0.8,
                        repeat: Infinity,
                        repeatType: "reverse"
                    }}
                    className={cn("text-base sm:text-xl md:text-3xl lg:text-5xl font-bold text-center", cursorClassName)}
                >
                    |
                </motion.span>
            ) : (
                <span className={cn("text-base sm:text-xl md:text-3xl lg:text-5xl font-bold text-center", cursorFinishedClassName)}>|</span>
            )}
        </div>
    );
};
